import React from "react";
import { Container } from "react-bootstrap";
export interface IGridContainer {
  children?: React.ReactNode;
  parentClass?: string;
  fluid?: boolean | string | "sm" | "md" | "lg" | "xl" | "xxl";
}

const GridContainer = (props: IGridContainer) => {
  return (
    <Container className={props.parentClass} fluid={props.fluid}>
      {props.children}
    </Container>
  );
};

export default GridContainer;
